import styled from 'styled-components';

import { layout, media } from 'src/components/base';

import RichText from '../rich-text';

export const TextText = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  ${media.smallOnly`
    flex-direction: column;
  `};
`;

type TextProps = {
  width: string;
};

export const TextBefore = styled(RichText)<TextProps>`
  width: ${p => p.width};
  padding-right: ${layout.measurements.spacing100};

  ${media.smallOnly`
    width: 100%;
    padding-right: 0;
    padding-bottom: ${layout.measurements.spacing100};
  `};
`;

export const TextAfter = styled(RichText)<TextProps>`
  width: ${p => p.width};
  padding-left: ${layout.measurements.spacing100};

  ${media.smallOnly`
    width: 100%;
    padding-left: 0;
    padding-top: ${layout.measurements.spacing100};
  `};
`;
